<template>
  <div class="cs-fullheight cs-pagination-container">
    <div class="cs-pagination-header">
      <el-button
        class="cs-pagination-header-add"
        v-if="option.hasAddButton"
        type="primary"
        plain
        icon="el-icon-plus"
        @click="handleAdd"
      >{{option.addButtonText}}</el-button>
      <el-input
        class="cs-pagination-header-search"
        v-if="option.hasSearch"
        placeholder="搜索"
        size="medium"
        clearable
        suffix-icon="el-icon-search"
        v-model="searchWord"
        @change="onSearchConditionChanged"
      > </el-input>
      <div
        v-if="option.hasDateSearch"
        class="cs-pagination-searchDate-Container"
      >
        <el-date-picker
          class="cs-pagination-searchDate"
          v-model="searchDate"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        ></el-date-picker>
        <el-button
          class="cs-pagination-header-add"
          type="primary"
          plain
          icon="el-icon-search"
          @click="handleSearch"
        >搜索</el-button>
      </div>
    </div>
    <div class="cs-pagination-table-container">
      <el-table
        stripe
        ref="paginationTable"
        :data="tableData"
        @sort-change="sortChange"
        @filter-change="filterChange"
        style="width: 100%;"
        @cell-dblclick="handleCellDbClick"
        :row-class-name="tableRowClassName"
        :cell-class-name="cellStyle"
        header-row-class-name="el-table-header"
        @select="onCheck"
        :height="500"
      >
        <el-table-column
          v-if="option.hasChecked"
          :label="option.checkedColumnTite"
          type="selection"
          width="55"
        ></el-table-column>  
        <el-table-column
          :filter-multiple="col.IsFilterMutiple"
          :column-key="col.Name"
          :sortable="false"
          :filters="null"
          :filter-method="null"        
          :key="colIndex"
          v-for="(col, colIndex) in displayedColumns"
          :prop="col.Name"
          :label="col.Text"
          :min-width="getColumnWidth(col.Width)"
        >
          <template slot-scope="scope">
            <component
              v-if="!!col.Component"
              :is="col.Component"
              :data="scope.row"
              :editLocation="editLocation"
              :columnData="col"
              :status="status"
              @reload="onReload"
              @customEvent="customEventHanlder"
            ></component>
            <span
              v-if="!col.Component"
              v-bind:class="{'color-label': col.IsColorLabel,
            'color-active': scope.row.Active=='已激活' && col.Name =='Active' && option.showAcitveColor ,
            'color-close':(scope.row.Active=='关闭') && col.Name =='Active' && option.showAcitveColor
            }"
              :style="col.Style"
            >{{ scope.row[col.Name] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="option.hasChangeCourseButton"
          :label="option.enableColumnTite"
        >
          <template slot-scope="scope">
            <el-button
              v-show="scope.row.IsShowChangeCourseButton"
              :type="'success'"
              size="mini"
              @click="handleChangeCourse(scope.$index, scope.row)"
            >{{'换课'}}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          v-if="option.hasEnableButton"
          :label="option.enableColumnTite"
        >
          <template slot-scope="scope">
            <el-button
              :type="getEnableButtonClass(scope)"
              size="mini"
              @click="handleEnable(scope.$index, scope.row)"
            >{{getEnableButtonText(scope)}}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          v-if="option.hasEditButton"
          :label="option.editColumnTite"
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              v-show="getRowEditVisible(scope.$index,scope.row)"
              @click="handleEdit(scope.$index, scope.row)"
            >{{getEditButtonText(scope)}}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          v-if="option.hasDeleteButton"
          :label="option.deleteColumnTite"
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="handleDelete(scope.$index, scope.row)"
            >{{getDeleteButtonText(scope)}}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          v-for="item in option.additionalColumns"
          :key="item.name"
          :label="item.title"
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="handleAdditional(item.name, scope.$index, scope.row)"
            >{{item.buttonText}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination
      v-if="option.displayPagination"
      class="cs-pagination"
      background
      @size-change="pageSizeChange"
      @current-change="currentPageChange"
      :current-page="currentPage"
      :page-sizes="[20, 50, 100]"
      :page-size="20"
      layout="total, sizes, prev, pager, next, jumper"
      :total="recordTotal"
    >
    </el-pagination>
  </div>
</template>


<style lang="scss">
.cs-pagination-container {
  position: relative;
  width: 100%;

  .cs-pagination-header {
    text-align: right;
    .cs-pagination-header-add {
      margin-right: 10px;
    }
    .cs-pagination-header-search {
      max-width: 200px;
      display: inline-block;
    }
    .cs-pagination-searchDate-Container {
      display: inline-block;
    }

    .cs-pagination-searchDate {
      min-width: 400px;
      vertical-align: middle;
    }
  }

  .cs-pagination-table-container {
    width: 100%;
    margin-top: 10px;

    .el-table {
      .el-table__body {
        td {
          padding-top: 5px;
          padding-bottom: 5px;
        }
      }
    }

    .color-label {
      background-color: #2ab893;
      color: #fff;
      padding: 5px 8px;
      border-radius: 5px;
    }

    .disabled-row {
      color: #bcbcbc;
      .color-label {
        background-color: #b2b2b2;
      }
    }

    .color-active {
      color: #2ab893;
    }

    .color-close {
      color: #bcbcbc;
    }
  }

  .cs-pagination {
    margin-top: 3px;
  }
}
</style>

<script>
import appointmentCourseNameCell from "./paginationCells/appointmentCourseNameCell";
import appointmentStatusCell from "./paginationCells/appointmentStatusCell";
import videoButtonCell from "./paginationCells/videoButtonCell";
import appointmentSignInStatusCell from "./paginationCells/appointmentSignInStatusCell";

export default {
  data() {
    return {
      loading: true,
      tableData: [],
      columns: [],
      displayedColumns: [],
      currentPage: 1,
      recordTotal: 0,
      pageSize: 20,
      sortField: "",
      isDesc: false,
      searchWord: "",
      searchDate: "",
      searchFilter: null,
      enableButtonClass: "primary",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      editLocation: {}
    };
  },
  components: {
    appointmentCourseNameCell,
    appointmentStatusCell,
    videoButtonCell,
    appointmentSignInStatusCell
  },
  created() {
  },
  props: {
    data: {},
    option: {},
    displayPagination: Boolean,
    hasEditButton: Boolean,
    editButtonText: String,
    editColumnTite: String,
    showAcitveColor: Boolean,
    hideDisableRow: Boolean,
    selectedKeyField: String,
    selectedKey: Number | String,
    status: {}
  },
  methods: {
    checkIsVisiable(col) {
      if (!col.IsHide) {
        if (!!col.VisibleField) {
 
          return this.option[col.VisibleField];
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    onReload() {
      this.loadData();
    },
    filterChange(filter) {
      this.searchFilter = filter;
      this.handleSearch();
    },
    getFilterOptions(list) {
      if (!!list && list.length > 0) {
        let options = [];
        list.forEach(element => {
          options.push({
            text: element.Value,
            value: element.Key
          });
        });
        return options;
      }
      return null;
    },
    filterHandler(value, row, column) {
      return true;
    },
    handleCellDbClick(row, column, cell, event) {
      let location = {
        rowIndex: row.Index,
        columnLabel: column.label
      };
      this.editLocation = location;
      this.$emit("cellDbClick", { column: column, row: row });
    },
    getColumnWidth(value) {
      if (!value) {
        return 100;
      }
      return value;
    },
    cellStyle(cell) {
      let cellClass = "";
      if ((cell.rowIndex + 1) % 2 == 1) {
        cellClass = "el-table-cell-single";
      } else {
        cellClass = "el-table-cell-double";
      }
      return cellClass;
    },
    doSearchWithOption(searchOption) {
      this.$emit("searchWithOption", searchOption);
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    handleSearch() {
      this.currentPage = 1;
      this.loadData();
    },
    getSearchOptions() {
      let startDate = ""; 
      let endDate = ""; 
      if (!!this.searchDate && this.searchDate.length == 2) {
        startDate = this.formatDate(this.searchDate[0]); 
        endDate = this.formatDate(this.searchDate[1]);
      }
      let searchOption = {
        startDate: startDate,
        endDate: endDate
      };
      if (!!this.searchFilter) {
        searchOption["filterList"] = this.searchFilter;
      } else {
        searchOption["filterList"] = null;
      }
      return searchOption;
    },
    onSearchConditionChanged() {
      this.$emit("search", this.searchWord);
      this.handleSearch();
    },
    handleEnable(index, row) {
      this.$emit("enableChange", index, row);
    },
    handleChangeCourse(index, row) {
      this.$emit("changeCourseClick", index, row);
    },
    handleAdd() {
      this.$emit("add");
    },
    handleEdit(index, row) {
      this.$emit("edit", index, row);
    },
    getRowEditVisible(index, row) {
      if (this.option.fnRowEditVisible) {
        return this.option.fnRowEditVisible(index, row);
      }
      return this.option.hasEditButton;
    },
    handleDelete(index, row) {
      this.$emit("delete", index, row);
    },
    handleAdditional(name, index, row) {
      this.$emit("additional", name, index, row);
    },
    tableRowClassName({ row, rowIndex }) {
      if (this.option.hideDisableRow) {
        return "";
      }
      if (typeof row.IsActive != "undefined") {
        if (!row.IsActive) {
          return "disabled-row";
        }
      }
      return "";
    },
    getEnableButtonClass(scope) {
      if (!!scope.row && !!scope.row.Enable) {
        return "primary";
      }
      return "info";
    },
    getEnableButtonText(scope) {
      if (!!scope.row && !!scope.row.Enable) {
        return "启用";
      }
      return "停用";
    },
    getEditButtonText(scope) {
      if (!this.option.editButtonText) {
        return "编辑";
      }
      if (!!scope.row && scope.row.editButtonText) {
        return scope.row.editButtonText;
      }
      return this.option.editButtonText;
    },
    getDeleteButtonText(scope) {
      if (!this.option.deleteButtonText) {
        return "删除";
      }
      return this.option.deleteButtonText;
    },
    sortChange(data) {
      if (data.order == "descending") {
        this.isDesc = true;
      } else {
        this.isDesc = false;
      }
      this.sortField = data.prop;

      this.loadData();
    },
    loadData() {
      let pageData = {
        pageSize: this.pageSize,
        pageNumber: this.currentPage,
        sortField: this.sortField,
        isDesc: this.isDesc,
        keyWord: this.searchWord
      };

      let startDate = ""; 
      let endDate = ""; 
      if (!!this.searchDate && this.searchDate.length == 2) {
        startDate = this.formatDate(this.searchDate[0]); 
        endDate = this.formatDate(this.searchDate[1]);
      }
      pageData["startDate"] = startDate;
      pageData["endDate"] = endDate;
      if (!!this.searchFilter) {
        pageData["filterList"] = this.searchFilter;
      } else {
        pageData["filterList"] = null;
      }

      this.$emit("loadData", pageData);
    },
    pageSizeChange(value) {
      this.pageSize = value;
      this.currentPage = 1;
      this.$emit("pageSizeChange", value);
      this.loadData();
    },
    currentPageChange(value) {
      this.currentPage = value;
      this.$emit("currentPageChange", value);
      this.loadData();
    },
    initSetting() {    
    },
  
    onCheck(selection, row) {
      this.$refs.paginationTable.clearSelection();
      let isChecked = true;
       
      if (!!row) {
        this.selectioned = row;
        this.$refs.paginationTable.toggleRowSelection(row, true);
        this.$emit("checkChange", row, isChecked);
      }
    },
    onCheckChange(row) {
      if (row.length === 0) {
        this.selectioned = null;
      }
    },
    setSelectedRow(){
      if (!!this.tableData && this.selectedKeyField && this.selectedKey){
        this.tableData.forEach(element => {
          if (element[this.selectedKeyField] == this.selectedKey){
            this.$refs.paginationTable.toggleRowSelection(element,true);
            this.$emit("checkChange", element, true);
          }
        });
      }
    },
    customEventHanlder(data){
      this.$emit("customEvent", data);
    }
  },
  watch: {
    data: function() {
      this.initSetting();
      if (!!this.data) {
        this.currentPage = this.data.CurrentPage;
        this.recordTotal = this.data.RecordCount;
        this.columns = this.data.Columns;
        this.tableData = this.data.Results;
        this.displayedColumns = this.columns.filter(i =>{
          return this.checkIsVisiable(i);
        });
      } else {
        this.tableData = [];
        this.recordTotal = 0;
        this.currentPage = 1;
      }
      this.$nextTick(function(){
        this.setSelectedRow();
      });
      this.loading = false;
    },
    selectedKey: function(){
      this.setSelectedRow();
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/common/pagination.vue